import { render, staticRenderFns } from "./Archivo.vue?vue&type=template&id=11bc966a"
import script from "./Archivo.vue?vue&type=script&lang=js"
export * from "./Archivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports